import {camelizeKeys, decamelizeKeys} from 'humps';

export enum PaymentType {
    INVOICE = 'invoice',
    GATEWAY = 'gateway',
    ACCOUNT = 'account',
}

export interface Deposit {
    id?: number | string;
    amount: number;
    percentage: number;
    appliesTo?: PaymentType;
}

export interface DepositRule extends Deposit {
    readonly?: boolean;
    isNewRecord?: boolean;
    min?: number;
    max?: number;
    isAmountValid?: boolean;
    isPercentaceValid?: boolean;
}

export interface DespositApi {
    id?: number;
    amount: number;
    percentage: number;
    applies_to: PaymentType;
}

export const mapToDeposit = (rawDeposit: DespositApi) => {
    return camelizeKeys(rawDeposit) as Deposit;
};

export const mapToRawDeposit = (deposit: Deposit) => {
    return decamelizeKeys(deposit) as DespositApi;
};

export const mapDepositRules = (deposit: DepositRule): Deposit => {
    return {
        amount: deposit.amount,
        percentage: deposit.percentage,
        appliesTo: deposit.appliesTo,
    };
};
